import { useCallback, useEffect, useMemo, useState } from "react";
import { message } from "antd";
import { filterByTitle } from "../utils";

export function useEvaluationsLists({ accessToken, therapistId, evalApi }) {
  // UI state
  const [tab, setTab] = useState("standard"); // standard | my
  const [area, setArea] = useState(undefined);
  const [search, setSearch] = useState("");

  // data
  const [standardRaw, setStandardRaw] = useState([]);
  const [myRaw, setMyRaw] = useState([]);

  const [standardLoading, setStandardLoading] = useState(false);
  const [myLoading, setMyLoading] = useState(false);

  const loading = standardLoading || myLoading;

  const loadStandard = useCallback(async () => {
    if (!accessToken) return;
    setStandardLoading(true);
    try {
      const { evaluations } = await evalApi.getCatalog(accessToken, {
        page: 1,
        limit: 50,
        area,
        type: "standardized",
      });
      setStandardRaw(evaluations || []);
    } catch (e) {
      console.error(e);
      message.error(
        e?.message || "No se pudieron cargar las evaluaciones estándar",
      );
      setStandardRaw([]);
    } finally {
      setStandardLoading(false);
    }
  }, [accessToken, area, evalApi]);

  const loadMy = useCallback(async () => {
    if (!accessToken || !therapistId) return;
    setMyLoading(true);
    try {
      const { evaluations } = await evalApi.getMyEvaluations(
        accessToken,
        therapistId,
        {
          page: 1,
          limit: 50,
        },
      );
      setMyRaw(evaluations || []);
    } catch (e) {
      console.error(e);
      message.error(e?.message || "No se pudieron cargar tus evaluaciones");
      setMyRaw([]);
    } finally {
      setMyLoading(false);
    }
  }, [accessToken, therapistId, evalApi]);

  // inicial + recargas
  useEffect(() => {
    loadStandard();
  }, [loadStandard]);

  useEffect(() => {
    loadMy();
  }, [loadMy]);

  const standard = useMemo(
    () => filterByTitle(standardRaw, search),
    [standardRaw, search],
  );
  const myEvals = useMemo(() => filterByTitle(myRaw, search), [myRaw, search]);

  return {
    // ui
    tab,
    setTab,
    area,
    setArea,
    search,
    setSearch,

    // data
    loading,
    standard,
    myEvals,

    // refresh
    refreshStandard: loadStandard,
    refreshMy: loadMy,
  };
}
